// extracted by mini-css-extract-plugin
export default {"cancel":"EditMemberDetails_cancel__0XhHn"};